// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2M-_g","col":"Table_col__1Tn50","fulfillmentStatus":"Table_fulfillmentStatus__3pHbl","emailCol":"Table_emailCol__1_7hV"};